<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Jack Compton’s Luck</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="frontMatterPage" id="fm02"><a id="page02"><div class="chapterHead"><h2 class="chapterTitle"><span class="bold"><span>Author Note</span></span></h2></div><div class="chapterBody"><p class="paraNoIndent1"><span>After I had written two novels telling of the Chancellor twins Ritchie and Russell, and the part played in the first, <em class="italic"><span>Major Chancellor’s Mission,</span></em> by the charmed object called the Luck of the Comptons, it occurred to me that here was another interesting story waiting to be written.</span></p><p class="paraNoIndent1"><span>The Luck had passed out of the hands of the Comptons and into those of the Chancellors, with the promise that if ever the Comptons were to be in serious trouble again the Luck would find a way to return to them, and so offer them salvation.</span></p><p class="paraNoIndent1"><span>Just over a hundred years later, in the 1920s, the Comptons find themselves once more in financial difficulties. Jack Compton, trying to save his family home from ruin, meets Miss Lacey Chancellor, a descendant of Ritchie, and their love story takes place in events that echo those of her ancestor.</span></p><p class="paraNoIndent1"><span>I hope you enjoy reading about them as much as I enjoyed creating their adventures.</span></p></div></a></div>
<a id="page02">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// jackcomptonsluck_fm02.vue?c0854656